var ctrl = function($scope, Flash) {
  $scope.Flash = Flash;
};

ctrl.$inject = ['$scope', 'Flash'];

tiz.controller('AlertCtrl', ctrl);

tiz.directive('tizAlert', function() {
  return {
    controller: 'AlertCtrl',
    templateUrl: require('../templates/alert/alert.html')
  };
});
